var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar2650(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "40px",
    viewBox: "0 0 42 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star - 26-50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.631373 0 0 0 0 0.113725 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Learning-Activity---Progress---VD---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "star---26-50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.5376846,1.56879179 L28.4931575,11.5543101 L39.5739318,13.1555624 C41.8950836,13.4909857 42.8219083,16.3277302 41.1423071,17.955909 L33.1241835,25.728551 L35.0170057,36.7036977 C35.4135058,39.0027231 32.9870471,40.7559276 30.9109458,39.670475 L21,34.4887137 L11.0890542,39.670475 C9.01295292,40.7559276 6.5864942,39.0027231 6.98299426,36.7036977 L8.87581648,25.728551 L0.857692886,17.955909 C-0.821908322,16.3277302 0.104916437,13.4909857 2.42606822,13.1555624 L13.5068425,11.5543101 L18.4623154,1.56879179 C19.500366,-0.522930597 22.499634,-0.522930597 23.5376846,1.56879179 Z M21,2.81430803 L15.3860898,14.1266095 L2.83300487,15.9406214 L11.777,24.611 L30.222,24.611 L39.1669951,15.9406214 L26.6139102,14.1266095 L21,2.81430803 Z",
    id: "Combined-Shape",
    fill: "#383C40"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2650);
export default __webpack_public_path__ + "static/media/star-26-50.4cf366afc4ba75c8a2e38f33cd4ba285.svg";
export { ForwardRef as ReactComponent };